import React, { useRef, useEffect } from "react"
import SvgClose from "./svg/close"
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock"

export default ({ hideCloseButton, close, children }) => {
  const refModal = useRef(null)

  const handleClose = () => {
    if (close) close()
  }

  useEffect(() => {
    disableBodyScroll(refModal.current)
    return clearAllBodyScrollLocks
  }, [])

  return (
    <div
      className="fixed top-0 right-0 bottom-0 left-0 bg-charcoal-transparent-90 text-white overflow-hidden z-20"
      ref={refModal}
    >
      <div className="px-4 h-full">
        <div className="flex items-center justify-center w-full h-full relative">
          {!hideCloseButton && (
            <button
              type="button"
              onClick={handleClose}
              className="absolute right-0 top-0 mt-4 hover:text-orange focus:outline-none z-30 md:w-5 md:h-5 md:mt-8 lg:mt-9"
            >
              <SvgClose className="h-6 w-6 text-white"></SvgClose>
            </button>
          )}
          <div className="flex h-full w-full">
            <div className="w-full max-w-xl mx-auto py-12 md:py-20 lg:py-22 overflow-auto">
              <div className="flex flex-col justify-center h-full overflow-auto">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
